import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from "@angular/core";
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { DatePicker } from "@ionic-native/date-picker";
import { Platform } from "ionic-angular";
import { isDefined, isString } from "ionic-angular/util/util";
import * as moment from "moment";
import { BsDatepickerConfig, BsDatepickerDirective } from "ngx-bootstrap";
import { isDate } from "util";
import { dateToString } from "../../../../core/util/date-to-string";
import { ControlComponent } from "../../../controls/control.component";

@Component({
    selector: "vas-date-time",
    templateUrl: "date-time.component.html",
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DateTimeComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => DateTimeComponent), multi: true}
    ]
})
export class DateTimeComponent extends ControlComponent {
    @Input("_value") value: string;
    @Input() placeholder = "";
    @Input() displayFormat: string = "DD-MM-YYYY";
    @Input() internalFormat = "YYYY-MM-DD";

    @Output() changes: EventEmitter<any> = new EventEmitter();

    @ViewChild(BsDatepickerDirective) datePicker: BsDatepickerDirective;

    // value the calendar uses as the date that's displayed when it's opened
    datePickerValue: Date;

    constructor(
        protected elemRef: ElementRef,
        protected platform: Platform,
        protected datePickerNative: DatePicker
    ) {
        super(elemRef);
    }

    ngAfterViewInit(): void {
        this.datePicker.outsideClick = true;
    }

    get datePickerConfig(): Partial<BsDatepickerConfig> {
        return {
            dateInputFormat: this.displayFormat,
            value: this.datePickerValue
        };
    }

    /**
     * Returns the field's value formatted for display to the user
     * @return {any}
     */
    get displayValue(): string {

        if (!this.value) {
            return "";
        }

        const m = moment(this.value);

        return m.isValid() ? m.format(this.displayFormat) : this.value;
    }

    /**
     * Returns true if we are running on a desktop desktop browser
     * @return {boolean}
     */
    protected isDesktop(): boolean {
        return this.platform.is("core");
    }

    /**
     * Shows the date picker
     */
    showDatePicker(): void {
        if (this.isDesktop()) {
            this.showDatePickerDesktop();
        } else {
            this.showDatePickerNative();
        }
    }

    /**
     * Shows the desktop datepicker
     */
    protected showDatePickerDesktop(): void {
        this.datePicker.show();
    }

    /**
     * Shows the mobile native datepicker
     */
    protected showDatePickerNative(): void {

        this.datePickerNative.show({
            date: new Date(),
            mode: "date",
            androidTheme: this.datePickerNative.ANDROID_THEMES.THEME_HOLO_DARK
        }).then(
            date => this.updateValue(dateToString(date)),
            error => {
                // @todo
                console.error("error picking date", error);
            }
        );
    }

    /**
     * Set the initial value
     * @param value
     */
    writeValue(value: any): void {
        super.writeValue(value);
        if (value) {
            this.datePickerValue = new Date(value);
        }
    }

    updateValue(value: Date | string): void {

        if (!value) {
            return;
        }

        let date;

        if (isString(value)) {
            date = new Date(value);
        }

        if (isDate(value)) {
            date = value;
        }

        date = value;
        const m = moment(date);
        super.updateValue(m.format(this.internalFormat));
        return;
    }

    /**
     * Handles the hide date picker event - when the user picks a date on the desktop datepicker
     */
    onHideDatePickerDesktop(): void {
        const date = this.datePicker._bsValue;
        if (isDefined(date) && date !== this.datePickerValue) {
            this.updateValue(date);
        }
    }

    onInputChange($event): void {
        this.updateValue($event.srcElement.value);
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/controls/date-time/date-time.component.ts